import React from "react";
import { ServerPaginatedTable } from "../../../shared";
import { Button, Stack } from "@mui/material";
import { useStampUsageHistory } from "../hooks";
import { Link, useLocation } from "react-router-dom";
import InputControl from "../../../shared/components/InputControl";

export const StampUsageHistory = ({ isPublished = false }) => {
  const { pathname } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");

  const {
    state,
    handleSearch,
    onChangeDateFilter,
    handleFilterClear,
    handleApplyFilter,
    gotoPage,
    setPageSize,
  } = useStampUsageHistory();

  const columns = React.useMemo(
    () => [
      {
        Header: "Order Date",
        accessor: "order_date",
        Cell: ({ row }) => {
          const { type, status, redeemed_order_date, order_date } =
            row.original;
          const isRedeemed = type === "reward" && status === "Redeemed";
          const dateValue = isRedeemed ? redeemed_order_date : order_date;
          return dateValue ? dateValue : "-";
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer_name",
        Cell: ({ row }) => (
          <Link
            to={
              isStoreAdmin
                ? `/store-admin/customers/details/${row.original.customer_id}`
                : `/customers/details/${row.original.customer_id}`
            }
            style={{ textDecoration: "underline", color: "#000" }}
          >
            {row.original.customer_name}
          </Link>
        ),
      },
      {
        Header: "Order Number",
        accessor: "order_id",
        Cell: ({ row }) => {
          const {
            type,
            status,
            redeemed_order_id,
            redeemed_order_number,
            order_id,
            order_number,
          } = row.original;
          const isRedeemed = type === "reward" && status === "Redeemed";
          const orderId = isRedeemed ? redeemed_order_id : order_id;
          const orderNumber = isRedeemed ? redeemed_order_number : order_number;
          return (
            <Link
              to={
                isStoreAdmin
                  ? `/store-admin/orders/details/${orderId}`
                  : `/orders/details/${orderId}`
              }
              style={{ textDecoration: "underline", color: "#000" }}
            >
              {orderNumber}
            </Link>
          );
        },
      },
      {
        Header: "Collected Stamps",
        accessor: "collected_stamps",
      },
      {
        Header: "Unlocked Reward",
        accessor: "stamp_reward_name",
        Cell: ({ row, value }) => {
          return value ? value : "-";
        },
      },
    ],
    [isStoreAdmin],
  );

  return (
    <ServerPaginatedTable
      columns={columns}
      data={state.dataList}
      isLoading={state.isLoading}
      tableTitle={null}
      defaultSearch={false}
      filterApplied={state.filterApplied.all}
      onFilterClear={(e) => handleFilterClear("single", e)}
      onAllFilterClear={() => handleFilterClear("all")}
      gotoPage={gotoPage}
      setPageSize={setPageSize}
      pagination={state.pagination}
      handleSort={() => {}}
      sortByGlobal={[]}
      filterContent={
        <>
          <Stack
            direction="row"
            gap="16px"
            alignItems="center"
            flexWrap="wrap"
            width="100%"
          >
            <InputControl
              type="table-search"
              value={state.filterApplied.search}
              onChange={(e) => handleSearch(e.target.value)}
              onClear={() => handleSearch("")}
              sx={{ width: "calc(100% - 450px)", minWidth: "200px" }}
              placeholder="Search"
            />
            <InputControl
              type="datePicker"
              name="order_date"
              label="Order Date"
              inputFormat="dd-MM-yyyy"
              disableFuture
              value={state.filterApplied.order_date?.value || null}
              onChange={(date) => onChangeDateFilter(date)}
              sx={{ width: 200 }}
              onKeyDown={(e) => {
                e.preventDefault();
              }}
            />
          </Stack>
          <Button
            type="button"
            size="medium"
            variant="text"
            color="info"
            sx={{
              minWidth: "40px",
              p: "8px",
            }}
            onClick={handleApplyFilter}
            disabled={state.disableApplyButton}
          >
            Apply
          </Button>
        </>
      }
    />
  );
};
